import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import HeroIntro from "../../hero-intro/src";

import { CustomerStoriesDetailsHeroQuote } from "./customer-stories-details-hero-quote";

type Nullable<T> = T | null;

export interface CustomerStoriesDetailsHeroProps {
    title?: Nullable<string>;
    subtitle?: Nullable<string>;
    imgSrc?: Nullable<string>;
    imgAlt?: Nullable<string>;
    quote?: Nullable<string>;
    author?: Nullable<string>;
    role?: Nullable<string>;
    company?: Nullable<string>;
}

const heroContainerCss = css({
    display: "grid",
    justifyContent: "space-between",
    marginBlockStart: token("space.400"),
    maxWidth: "100%",
    boxSizing: "border-box",
    gap: "24px",
    width: "100%",
    gridTemplateColumns: "minmax(0, 1fr)",
    [media.above.md]: {
        gap: "32px"
    }
});

export const CustomerStoriesDetailsHero = ({
    title,
    subtitle,
    imgSrc,
    imgAlt,
    quote,
    author,
    role,
    company
}: CustomerStoriesDetailsHeroProps) => {
    return (
        <div css={heroContainerCss}>
            <HeroIntro
                title={title}
                subtitle={subtitle}
                alignment={imgSrc ? "left" : "center"}
            />
            {quote && (
                <CustomerStoriesDetailsHeroQuote
                    imgSrc={imgSrc}
                    imgAlt={imgAlt}
                    quote={quote}
                    author={author}
                    role={role}
                    company={company}
                />
            )}
        </div>
    );
};
